import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isSameOrBefore } from '../../utils/helper';
import FieldLabel from '../FieldLabel';
import FieldError from '../FieldError';
import { isDate } from '../../utils/validations';
import { errors } from '../../constants';
import { DateBox as DateBoxDevEx } from 'devextreme-react';

const DateBox = ({ testId, ...props }) => {
  const [isFocus, setFocus] = useState(false);
  const isDateSameOrBefore = props.allowFuture ? true : isSameOrBefore(props.value);
  const isValid = props.isValid && isDateSameOrBefore;
  const isLabel = props.label || !isValid;
  const showRequired = props.isRequired && (!props.value || !isDate(props.value));
  const errorMessage = !isDateSameOrBefore ? errors.FUTURE_DATE : props.errorText || errors.INCOMPLETE_DATA_FIELD;

  const handleFocusIn = e => {
    setFocus(true);
  };

  const handleFocusOut = e => {
    setFocus(false);
  };

  const onValueChanged = e => {
    (e && e.value) && props.onValueChanged(e);
  };

  return <>
    {isLabel && <div>
      {props.label && <FieldLabel text={props.label} />}
      {!props.hideErrorIcon && (!isValid || showRequired) && <FieldError isFocus={isFocus} error={errorMessage} />}
    </div>}
    <DateBoxDevEx
      {...props}
      labelMode='hidden'
      useMaskBehavior
      dateOutOfRangeMessage={null}
      onFocusIn={props.onFocusIn || handleFocusIn}
      onFocusOut={props.onFocusOut || handleFocusOut}
      isValid={showRequired ? props.value && isDate(props.value) : isValid}
      showClearButton={props.showClearButton && isFocus}
      elementAttr={{
        ...(testId && { 'data-testid': `${testId}-container` })
      }}
      inputAttr={{
        ...(testId && { 'data-testid': testId })
      }}
      displayFormat='MM/dd/yyyy'
      onValueChanged={onValueChanged} />
  </>;
};

DateBox.propTypes = {
  label: PropTypes.string,
  labelIcon: PropTypes.array,
  isValid: PropTypes.bool,
  isRequired: PropTypes.bool,
  showClearButton: PropTypes.bool,
  value: PropTypes.date,
  errorText: PropTypes.string,
  moreInfo: PropTypes.string,
  onFocusIn: PropTypes.func,
  onFocusOut: PropTypes.func,
  hideErrorIcon: PropTypes.bool,
  allowFuture: PropTypes.bool,
  onValueChanged: PropTypes.func,
  testId: PropTypes.string
};

DateBox.defaultProps = {
  isValid: true,
  allowFuture: false
};

export default DateBox;
